(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wuufu-coat-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wuufu-coat-finder')) {
  customElements.define('wuufu-coat-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      this.querySelectorAll('[data-coat-card]').forEach((card) => {
        const select = card.querySelector('[data-coat-select]');
        const search = card.querySelector('[data-coat-search]');
        const result = card.querySelector('[data-coat-result]');
        const originalOptions = Array.from(select.options).map((option) => option.cloneNode(true));
        const update = () => {
          const option = select.selectedOptions[0];
          result.hidden = !select.value;
          card.querySelector('[data-coat-title]').textContent = option?.dataset.coat || '';
          card.querySelector('[data-coat-advice]').textContent = option?.dataset.advice || '';
        };
        search.addEventListener('input', () => {
          const previous = select.value;
          const term = normalize(search.value);
          const filtered = originalOptions.filter((option) => !option.value || normalize(option.textContent).includes(term));
          select.replaceChildren(...filtered.map((option) => option.cloneNode(true)));
          select.value = filtered.some((option) => option.value === previous) ? previous : '';
          card.querySelector('[data-coat-empty]').hidden = filtered.length > 1;
          update();
        });
        select.addEventListener('change', update);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wuufu-coat-gatos-solo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wuufu-cat-pricing')) {
  customElements.define('wuufu-cat-pricing', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'yes';
      var select=this.querySelector('[data-wcat-select]');
      var result=this.querySelector('[data-wcat-result]');
      var intl=new Intl.NumberFormat('es-CO',{maximumFractionDigits:0});
      var update=()=>{
        var opt=select.selectedOptions[0];
        result.hidden=!select.value;
        if(!select.value)return;
        var name=opt.dataset.name||opt.textContent.trim();
        this.querySelector('[data-wcat-name]').textContent=name;
        this.querySelector('[data-wcat-prices-name]').textContent=name+':';
        this.querySelector('[data-wcat-coat]').textContent=opt.dataset.coat||'';
        this.querySelector('[data-wcat-advice]').textContent=opt.dataset.advice||'';
        var hasPrices=false;
        this.querySelectorAll('[data-wcat-row]').forEach(row=>{
          var n=row.dataset.wcatRow;
          var amount=Number(opt.dataset['price'+n]||0);
          row.hidden=amount<=0;
          if(amount>0)hasPrices=true;
          row.querySelector('[data-wcat-price]').textContent=amount>0?'$ '+intl.format(amount):'';
        });
        this.querySelector('[data-wcat-no-prices]').hidden=hasPrices;
      };
      select.addEventListener('change',update);
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wuufu-coat-gatos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wuufu-coat-finder')) {
  customElements.define('wuufu-coat-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      this.querySelectorAll('[data-coat-card]').forEach((card) => {
        const select = card.querySelector('[data-coat-select]');
        const result = card.querySelector('[data-coat-result]');
        const update = () => {
          const option = select.selectedOptions[0];
          result.hidden = !select.value;
          card.querySelector('[data-coat-title]').textContent = option?.dataset.coat || '';
          card.querySelector('[data-coat-advice]').textContent = option?.dataset.advice || '';
        };
        select.addEventListener('change', update);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wuufu-coat-perros-solo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wuufu-dog-pricing')) {
  customElements.define('wuufu-dog-pricing', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'yes';
      var select=this.querySelector('[data-wcat-select]');
      var result=this.querySelector('[data-wcat-result]');
      var intl=new Intl.NumberFormat('es-CO',{maximumFractionDigits:0});
      var update=()=>{
        var opt=select.selectedOptions[0];
        result.hidden=!select.value;
        if(!select.value)return;
        var name=opt.dataset.name||opt.textContent.trim();
        this.querySelector('[data-wcat-name]').textContent=name;
        this.querySelector('[data-wcat-prices-name]').textContent=name+':';
        this.querySelector('[data-wcat-coat]').textContent=opt.dataset.coat||'';
        this.querySelector('[data-wcat-advice]').textContent=opt.dataset.advice||'';
        var sizeRow=this.querySelector('[data-wcat-size-row]');
        sizeRow.hidden=!opt.dataset.size;
        this.querySelector('[data-wcat-size]').textContent=opt.dataset.size||'';
        var hasPrices=false;
        this.querySelectorAll('[data-wcat-row]').forEach(row=>{
          var n=row.dataset.wcatRow;
          var amount=Number(opt.dataset['price'+n]||0);
          row.hidden=amount<=0;
          if(amount>0)hasPrices=true;
          row.querySelector('[data-wcat-price]').textContent=amount>0?'$ '+intl.format(amount):'';
        });
        this.querySelector('[data-wcat-no-prices]').hidden=hasPrices;
      };
      select.addEventListener('change',update);
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wuufu-coat-perros"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wuufu-coat-finder')) {
  customElements.define('wuufu-coat-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      this.querySelectorAll('[data-coat-card]').forEach((card) => {
        const select = card.querySelector('[data-coat-select]');
        const result = card.querySelector('[data-coat-result]');
        const update = () => {
          const option = select.selectedOptions[0];
          result.hidden = !select.value;
          card.querySelector('[data-coat-title]').textContent = option?.dataset.coat || '';
          card.querySelector('[data-coat-advice]').textContent = option?.dataset.advice || '';
        };
        select.addEventListener('change', update);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wuufu-home2"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('wuufu-home')) {
  customElements.define('wuufu-home', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('[data-finder]');
      const open = this.querySelector('[data-open-finder]');
      const close = this.querySelector('[data-close-finder]');
      const form = this.querySelector('[data-finder-form]');
      const result = this.querySelector('[data-finder-result]');
      open.addEventListener('click', () => dialog.showModal());
      close.addEventListener('click', () => dialog.close());
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const species = form.elements.pet.value;
        const option = form.elements.need.selectedOptions[0];
        const path = species === 'dog' ? option.dataset.dog : option.dataset.cat;
        if (!path) return;
        this.querySelector('[data-result-link]').href = path;
        result.hidden = false;
        this.querySelector('[data-result-link]').focus();
      });
      form.addEventListener('change', () => { result.hidden = true; });
      dialog.addEventListener('click', (event) => { if (event.target === dialog) { const box=dialog.getBoundingClientRect(); if(event.clientX<box.left || event.clientX>box.right || event.clientY<box.top || event.clientY>box.bottom)dialog.close(); } });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wuufu-home3"] && !Shopify.designMode) return;
  try {
    


if (!customElements.get('wuufu-home3')) {
  customElements.define('wuufu-home3', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('[data-finder]');
      const open = this.querySelector('[data-open-finder]');
      const close = this.querySelector('[data-close-finder]');
      const form = this.querySelector('[data-finder-form]');
      const result = this.querySelector('[data-finder-result]');
      open.addEventListener('click', () => dialog.showModal());
      close.addEventListener('click', () => dialog.close());
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const species = form.elements.pet.value;
        const option = form.elements.need.selectedOptions[0];
        const path = species === 'dog' ? option.dataset.dog : option.dataset.cat;
        if (!path) return;
        this.querySelector('[data-result-link]').href = path;
        result.hidden = false;
        this.querySelector('[data-result-link]').focus();
      });
      form.addEventListener('change', () => { result.hidden = true; });
      dialog.addEventListener('click', (event) => { if (event.target === dialog) { const box=dialog.getBoundingClientRect(); if(event.clientX<box.left || event.clientX>box.right || event.clientY<box.top || event.clientY>box.bottom)dialog.close(); } });
    }
  });
}



  } catch(e) { console.error(e); }
})();
})();
